export type SelectKey =
  | "ArrowDown"
  | "ArrowUp"
  | "Home"
  | "End"
  | "Enter"
  | " "
  | "Escape";

export const isSelectNavKey = (key: string): key is SelectKey => {
  return (
    key === "ArrowDown" || key === "ArrowUp" || key === "Home" || key === "End"
  );
};

export const isSelectOpenKey = (key: string): key is SelectKey => {
  return (
    key === "ArrowDown" || key === "ArrowUp" || key === "Enter" || key === " "
  );
};

export const isSelectCommitKey = (key: string): key is SelectKey => {
  return key === "Enter" || key === " ";
};

export const isSelectCloseKey = (key: string): key is SelectKey => {
  return key === "Escape";
};

export const getNextSelectIndex = (params: {
  key: string;
  currentIndex: number;
  count: number;
}): number | null => {
  const { key, currentIndex, count } = params;
  if (count <= 0) return null;
  const lastIndex = count - 1;

  if (key === "ArrowDown") return Math.min(currentIndex + 1, lastIndex);
  if (key === "ArrowUp") return Math.max(currentIndex - 1, 0);
  if (key === "Home") return 0;
  if (key === "End") return lastIndex;
  return null;
};
